import { render, staticRenderFns } from "./EmptyImage.vue?vue&type=template&id=9077f0a8&"
import script from "./EmptyImage.vue?vue&type=script&lang=js&"
export * from "./EmptyImage.vue?vue&type=script&lang=js&"
import style0 from "./EmptyImage.vue?vue&type=style&index=0&id=9077f0a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports